import fill from 'lodash/fill';

import { useAddBundlesMutation$variables } from '__generated__/useAddBundlesMutation.graphql';
import { SelectedPlan } from '../typings/plans';

interface BuildAddBundlesInputBundlesProps {
  selectedPlans: SelectedPlan[];
  accountNumber?: string;
}

export function buildAddBundlesInputBundles({
  selectedPlans,
  accountNumber,
}: BuildAddBundlesInputBundlesProps): useAddBundlesMutation$variables['input']['bundles'] {
  return selectedPlans.flatMap((selectedPlan) => {
    const bundle: useAddBundlesMutation$variables['input']['bundles'][0] = {
      categoryId: 'mobile',
      accountNumber,
      items: [
        {
          offerId: selectedPlan.offerId,
          quantity: 1,
          action: 'add',
        },
      ],
    };
    return fill(Array(selectedPlan.quantity), bundle);
  });
}
